var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonBadgeEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,2C6.2,2,6,2.2,6,2.5S6.2,3,6.5,3h3C9.8,3,10,2.8,10,2.5S9.8,2,9.5,2H6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,0C3.1,0,2,1.1,2,2.5V14c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V2.5C14,1.1,12.9,0,11.5,0H4.5z M13,10.5v2.9 c0,0.8-0.7,1.5-1.5,1.5h-7c-0.8,0-1.5-0.7-1.5-1.5v-2.9v-0.3V2.5C3,1.7,3.7,1,4.5,1h7C12.3,1,13,1.7,13,2.5v7.7V10.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBadgeEmpty);
export default __webpack_public_path__ + "static/media/person-badge-empty.c5c3307bfaa7d81ac89c8b411ce724db.svg";
export { ForwardRef as ReactComponent };